import { updatePontTypeValue } from '../utils/updatePontTypeValue';
import { ConsentString } from 'consent-string';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { loadGdprAdConsentString } from 'owa-gdpr-ad-consent-string';
import { areAdsEnabled } from 'owa-mail-ads-checker';
import { isGdprAdMarket, isGdprTcfV3FlightEnabled } from 'owa-mail-ads-shared';
import PontType from 'owa-service/lib/contract/PontType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default async function shouldPrompt() {
    if (
        !isFeatureEnabled('fwk-gdprAdsPrefs') || // GDPR ads flight
        isFeatureEnabled('fwk-gdprAdsV2') || // GRPR Ads v2 flight is on
        isGdprTcfV3FlightEnabled() || // GDPR Ads v3 flight is on
        !areAdsEnabled() || // We only need to prompt if this user receives ads
        !isGdprAdMarket() // GDPR only applies to EU
    ) {
        return false;
    }

    let userConfiguration = getUserConfiguration();

    // The default PontType.GdprAdsPrefNotSet value means Ad prompt is never prompted
    let currentUserPonts = userConfiguration.UserOptions.NewEnabledPonts;
    let gdprAdsPrefEverPrompt =
        (currentUserPonts & PontType.GdprAdsPrefNotSet) != PontType.GdprAdsPrefNotSet;

    let consentString = await loadGdprAdConsentString();

    const consentDataEncodedString = new ConsentString(consentString);
    if (consentDataEncodedString.getCmpId() == 168) {
        if (!gdprAdsPrefEverPrompt) {
            // update everprompt. This means users which already set this bit long time before
            currentUserPonts &= ~PontType.GdprAdsPrefNotSet;
            updatePontTypeValue(currentUserPonts);
        }
        return false;
    }

    if (gdprAdsPrefEverPrompt) {
        // This means SDS thinks user has not GDPR but user actually has already set it
        // We will suppress the prompt but log the error for troubleshooting
        logUsage(
            'GdprAdsWrongPrompt',
            { consentString: consentString },
            {
                isCore: true,
            }
        );
        return false;
    }

    return true;
}
